import React, { useState, useEffect } from 'react';
import ReactTags from 'react-tag-autocomplete';
import PropTypes from 'prop-types';
import Select from "react-select";
import { getCustomFieldKeys } from '@api/v4/resources/custom_fields';

const ScopeCustomFieldSelection = ({ updateScope, scope }) => {
  const [scopeResources, updateScopeResources] = useState([]);
  const [selectedKey, setSelectedKey] = useState(null);
  const [customFieldValueInput, setCustomFieldValueInput] = useState('');
  const [selectedCustomFieldValues, setSelectedCustomFieldValues] = useState([]);

  useEffect(() => {
    const options = { resourceKey: BFG.resource.key, resourceType: BFG.resource.type };
    getCustomFieldKeys(options).then((resources) => {
      updateScopeResources(resources);
      if (scope) {
        const editableKey = resources.find(({ id }) => (id === scope?.custom_field_keys[0]));
        setSelectedKey({ value: editableKey.id, label: editableKey.attributes.name });
        setSelectedCustomFieldValues(scope?.values || []);
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (selectedCustomFieldValues.length > 0) {
      updateScope({ custom_field_keys: [selectedKey.value], values: selectedCustomFieldValues });
    } else {
      updateScope(null);
    }
  }, [selectedCustomFieldValues, selectedKey, updateScope]);

  const customFieldKeysOptions = () => (
    scopeResources.map(({ id, attributes }) => ({ value: id, label: attributes.name }))
  );

  const renderKeyDropdown = () => (
    <Select
      className="rules-key-dropdown"
      clearable={false}
      onChange={setSelectedKey}
      options={customFieldKeysOptions()}
      searchable
      value={selectedKey}
    />
  );

  const handleCustomFieldValueAddition = () => {
    setSelectedCustomFieldValues((prevState) => ([...prevState, customFieldValueInput]));
    setCustomFieldValueInput('');
  };

  const handleCustomFieldValueDeletion = (index) => {
    const newCustomFieldValues = [...selectedCustomFieldValues];
    newCustomFieldValues.splice(index, 1);
    setSelectedCustomFieldValues(newCustomFieldValues);
  };

  const valueComponent = (props) => (
    <div className="react-tags__selected-tag">
      <span className="value-tag">{props.tag.name}</span>
      <button
        className="react-tags__remove"
        onClick={props.onDelete}
        type="button"
      >
        <span className="bff-close" />
      </button>
    </div>
  );

  const renderValueInput = () => (
    <div className="modal-row">
      <ReactTags
        allowBackspace={false}
        allowDeleteFromEmptyInput={false}
        allowNew
        autofocus={false}
        classNames={{ tags: 'values-container', searchInput: 'inputs' }}
        delimiters={[9, 13, 188]}
        handleAddition={handleCustomFieldValueAddition}
        handleDelete={handleCustomFieldValueDeletion}
        handleInputChange={setCustomFieldValueInput}
        minQueryLength={1}
        placeholder={bfTranslate("Type to add a value")}
        tagComponent={valueComponent}
        tags={selectedCustomFieldValues.map((value) => ({ id: value, name: value }))}
      />
    </div>
  );

  return (
    <div className="rules-modal-container">
      <span className="bf-label bf-label--primary">{bfTranslate('Select Key')}</span>
      {renderKeyDropdown()}
      {!!selectedKey && (
        <div className="values-container">
          {renderValueInput()}
        </div>
      )}
    </div>
  );
};

ScopeCustomFieldSelection.propTypes = {
  updateScope: PropTypes.func.isRequired,
  scope: PropTypes.shape({})
};

ScopeCustomFieldSelection.defaultProps = {
  scope: false
};

export default ScopeCustomFieldSelection;
